export default ":host {\n  display: block;\n  margin-bottom: 1.5rem;\n}";